import React from 'react';

const CreateNew = () => (
<svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 33C1 17.915 1 10.3726 5.6863 5.6863C10.3726 1 17.915 1 33 1C48.0848 1 55.6275 1 60.3136 5.6863C65 10.3726 65 17.915 65 33C65 48.0848 65 55.6275 60.3136 60.3136C55.6275 65 48.0848 65 33 65C17.915 65 10.3726 65 5.6863 60.3136C1 55.6275 1 48.0848 1 33Z" fill="#EFE5FF" stroke="#2B2D42" stroke-width="2"/>
<path d="M42.6 32.9999H33H42.6ZM33 32.9999H23.4H33ZM33 32.9999V23.3999V32.9999ZM33 32.9999V42.5999V32.9999Z" fill="#EFE5FF"/>
<path d="M42.6 32.9999H33M33 32.9999H23.4M33 32.9999V23.3999M33 32.9999V42.5999" stroke="#2B2D42" stroke-width="2" stroke-linecap="round"/>
</svg>

);

export default CreateNew;
